import * as React from 'react';

import TrackedDiv from 'bundles/page/components/TrackedDiv';
import DataSourceLoader from 'bundles/promo-template/contentful/core/DataSourceLoader';
import ModuleRenderer from 'bundles/promo-template/contentful/modules/ModuleRenderer';
import type { PageData } from 'bundles/promo-template/queries/hooks/useEmbeddedPageContentQuery';

type Props = {
  page: PageData;
};

export default function EmbeddedPageContent({ page }: Props) {
  const { blocks } = page;

  return (
    <TrackedDiv
      withVisibilityTracking
      trackClicks={false}
      trackingName="embedded_promo_template_page"
      requireFullyVisible={false}
    >
      <DataSourceLoader dataSources={['program' as const]} />
      <ModuleRenderer modules={blocks} />
    </TrackedDiv>
  );
}
